import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { ViewContactInformation } from "Services/MicrobiologyResultData";
import useLang from "Shared/hooks/useLanguage";
import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

interface ViewContactsModalProps {
  show: boolean;
  onHide: () => void;
  id?: number;
}

const ViewContactsModal: React.FC<ViewContactsModalProps> = ({ show, onHide, id }) => {
  const { t } = useLang();
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState<any>({
    facilityPhone: "",
    primaryContactName: "",
    primaryContactPhone: "",
    primaryContactEmail: "",
    criticalName: "",
    criticalPhone: "",
    criticalContactEmail: "",
  });

  const fetchContactInformation = useCallback(async () => {
    if (!id) return;
    
    setLoading(true);
    try {
      const response = await ViewContactInformation(id);
      if (response?.data?.data) {
        setContactData(response.data.data);
      } else {
        toast.error(t(response?.data?.message || "Failed to load contact information"));
      }
    } catch (error: any) {
      console.error("Error loading contact information:", error);
      toast.error(t(error?.response?.data?.message || "Error loading contact information"));
    } finally {
      setLoading(false);
    }
  }, [id, t]);

  useEffect(() => {
    if (show && id) {
      fetchContactInformation();
    } else if (!show) {
      setContactData({
        facilityPhone: "",
        primaryContactName: "",
        primaryContactPhone: "",
        primaryContactEmail: "",
        criticalName: "",
        criticalPhone: "",
        criticalContactEmail: "",
      });
    }
  }, [show, id, fetchContactInformation]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="py-4 d-flex justify-content-between align-items-center">
        <Modal.Title className="h5 fw-bold">View Contacts</Modal.Title>
        <IconButton
          onClick={onHide}
          aria-label="close"
          size="small"
          sx={{ ml: 2 }}
        >
          <CloseIcon />
        </IconButton>
      </Modal.Header>
      <Modal.Body className="py-4 px-4">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">{t("Loading...")}</span>
            </div>
          </div>
        ) : (
          <div className="table_bordered overflow-hidden">
            <table className="table table-bordered mb-0">
              <tbody>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Facility Phone #</td>
                  <td className="text-dark text-start py-2">{contactData.facilityPhone || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Primary Contact Name</td>
                  <td className="text-dark text-start py-2">{contactData.primaryContactName || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Primary Contact Phone #</td>
                  <td className="text-dark text-start py-2">{contactData.primaryContactPhone || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Primary Contact Email</td>
                  <td className="text-dark text-start py-2">{contactData.primaryContactEmail || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Critical Contact Name</td>
                  <td className="text-dark text-start py-2">{contactData.criticalName || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Critical Contact Phone #</td>
                  <td className="text-dark text-start py-2">{contactData.criticalPhone || "-"}</td>
                </tr>
                <tr>
                  <td className="fw-bold text-dark text-start py-2">Critical Contact Email</td>
                  <td className="text-dark text-start py-2">{contactData.criticalContactEmail || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="py-2 border-0">
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={onHide}
        >
          {t("Cancel")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewContactsModal;
